module.exports = __webpack_public_path__ + "static/media/thomas.f5602b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/thomas.jpg
// module id = 612
// module chunks = 0